import { Capacitor } from '@capacitor/core';

export const isNative = (): boolean => Capacitor.isNativePlatform();
export const platform = (): 'web' | 'ios' | 'android' =>
  Capacitor.getPlatform() as 'web' | 'ios' | 'android';
